import { z } from 'zod';

export const SafeStatusSchema = z.enum([
  'EM_ESTOQUE',
  'ALOCADO',
  'SUSPENSO',
  'EM_DEVOLUCAO',
  'DESATIVADO',
]);

export type SafeStatus = z.infer<typeof SafeStatusSchema>;

export type EquipamentoStatus = SafeStatus;

export const SAFE_STATUS_TRANSITIONS: Record<SafeStatus, SafeStatus[]> = {
  EM_ESTOQUE: ['ALOCADO'],
  ALOCADO: ['SUSPENSO', 'EM_DEVOLUCAO'],
  SUSPENSO: ['ALOCADO', 'EM_DEVOLUCAO'],
  EM_DEVOLUCAO: ['EM_ESTOQUE', 'DESATIVADO'],
  DESATIVADO: [],
};

export const ColetaStatusSchema = z.enum([
  'AGENDADA',
  'CONFIRMADA',
  'EM_ROTA',
  'COLETADA',
  'AGUARDANDO_CONCILIACAO',
  'CONCILIADA',
  'DIVERGENCIA',
]);

export type ColetaStatus = z.infer<typeof ColetaStatusSchema>;
